/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Credentials_ErrorInputs */

const es_tools_nexata_list_credentials_error = /** @type {(inputs: Tools_Nexata_List_Credentials_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al verificar integraciones`)
};

const en_tools_nexata_list_credentials_error = /** @type {(inputs: Tools_Nexata_List_Credentials_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error checking integrations`)
};

/**
* | output |
* | --- |
* | "Error checking integrations" |
*
* @param {Tools_Nexata_List_Credentials_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_credentials_error = /** @type {((inputs?: Tools_Nexata_List_Credentials_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Credentials_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_credentials_error(inputs)
	return en_tools_nexata_list_credentials_error(inputs)
});
export { tools_nexata_list_credentials_error as "tools.nexata.list_credentials_error" }